"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "novi-di-modena": {
    "7f1d6c42": [{
      "hkey": "43718fd9",
      "slug": "rovereto-sulla-secchia",
      "name": "Rovereto sulla Secchia",
      "primary": true,
      "skipSearch": false
    }],
    "rovereto": [{
      "hkey": "43718fd9",
      "slug": "rovereto-sulla-secchia",
      "name": "Rovereto sulla Secchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;